module.exports = __webpack_public_path__ + "static/lobster-d3e5f5e89ae25a61468b68513848cbf6.jpg";